import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { industryAds } from '@/config/ads';

const Automotive: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="automotive"
      industry="Automotive"
      heroHeadline="Give shoppers the ability to explore before they ever visit the showroom."
      heroSubheadline="Create interactive vehicle experiences that let buyers configure, compare, and connect with your brand."
      section2Title="Car research is interactive by nature."
      section2Content="Car buyers spend weeks researching before they ever step foot in a dealership. Interactive ads let them explore trims, colors, features, and pricing right from the ad—moving them further down the funnel before they arrive."
      section3Title="High-impact formats lift engagement and lead quality."
      section3Content="When shoppers can interact with vehicles—spinning 360° views, exploring interiors, comparing models—they engage more deeply and arrive at dealerships more informed and ready to buy."
      section4Title="Ideal for OEMs, EV brands, dealerships, and auto marketplaces."
      section4Content="Whether you're launching a new model or driving dealer traffic, Adventive helps you create the digital showroom experience modern car buyers expect."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838626249_ab28e6e1.jpg"
      heroAd={industryAds.automotive1}
      section2Ad={industryAds.automotive2}
      section3Ad={industryAds.automotive3}
      accentColor="bg-slate-200 text-slate-700"
      stats={[
        { value: '4.2x', label: 'Engagement rate' },
        { value: '+90%', label: 'Time on ad' },
        { value: '2.8x', label: 'Lead quality' },
        { value: '35%', label: 'Lower cost per lead' },
      ]}
      benefits={[
        'OEMs and manufacturers',
        'EV and electric vehicle brands',
        'Dealership groups',
        'Auto marketplaces and classifieds',
      ]}
    />
  );
};

export default Automotive;
